import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "../../shared/helpers/InputFieldState";

interface CheckBoxProps {
    label: string;
    state?: InputFieldState
    onChange?: (value: string, isChecked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
    errorMessage?: string,
}

/**
 * Text Input Element
 */
export class CheckBox extends React.Component<CheckBoxProps> {

    public static defaultProps = {
        label: "Label",
    };
    state: {
        isChecked: boolean,
    };

    constructor(props: any) {
        super(props);

        this.state = {
            isChecked: this.props.state.isChecked == true,
        };
    }

    componentDidUpdate(prevProps: CheckBoxProps) {
        if (prevProps.state !== this.props.state) {
            this.setState({
                isChecked: this.props.state.isChecked
            });
        }
    }

    render() {
        return <label className="bold"><input
            disabled={this.props.state.editable === false} onChange={(event) => {
            const newState = !this.state.isChecked;
            this.setState({isChecked: newState});
            this.props.onChange(event.target.value, newState, event);
        }} value={this.props.state.value as string} type="checkbox" checked={this.state.isChecked}/> {this.props.label}{this.props.children}
            <div className="error_message">{this.props.state.errorMessage}</div>
        </label>
    }
}
